import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({ selector: '[appNewReportOptionsTemplate]' })
export class NewReportOptionsTemplateDirective {
  template = inject<TemplateRef<any>>(TemplateRef);
}
